import { useNavigate, useLocation } from "react-router-dom";
import React from "react";
import { TransactionsHome } from "us.collection.transactions/components";
import { INavigationData } from "us.collection/interfaces";
import { CaseType } from "us.helper/types/enums";

type Cnt_Transactions = {
  caseNo: number;
  caseType: CaseType;
};

const Cnt_Transactions: React.FC<Cnt_Transactions> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as INavigationData;
  const onMinimize = (url: string) => {
    navigate(url, { state });
  };

  return (
    <TransactionsHome
      onMinimize={() => onMinimize(`/case/${props.caseNo}`)}
      {...props}
    />
  );
};

export default Cnt_Transactions;
